import { render } from "./root-component.vue?vue&type=template&id=116d3302"
import script from "./root-component.ts?vue&type=script&lang=js"
export * from "./root-component.ts?vue&type=script&lang=js"

import "./root-component.scss?vue&type=style&index=0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__